var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('header',[_c('hgroup',[_vm._t("header",[_c('h1',{domProps:{"textContent":_vm._s(_vm.title)}})])],2),_vm._t("nav")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }